import { z } from 'zod/v4';

export const inviteSchema = z.object({
  entityType: z.string(),
  entityId: z.string(),
  toPhoneNumber: z.string(),
  body: z.string(),
  productFamily: z.string(),
});

export type Invite = z.infer<typeof inviteSchema>;
